

var form = document.querySelector(".postAsync");

if(form)
    form.addEventListener("submit", (e) => {

        e.preventDefault();
        var data = createFormData(form);

        var action = form.getAttribute("action");
        
        postAsync(action, data);
    });

function createFormData(form){

    var formData = new FormData(form);
    var data = {}; //skapar ett objekt som vi sätter värde på som finns i formuläret
    formData.forEach((value, key) => {data[key] = value});

    return data;
}

function postAsync(url, data, callback){

    httpPost(url, data).then(result => {

        console.log("post data");
        if(false && result && result.redirectUri)
            window.location.href = result.redirectUri;

        if(callback)
            callback(result);
    });
}

function httpGet (url, params, callback) {

    httpFetch(url, {method: "get"}, params, callback);
}

function httpPost(url, data, params, callback) {

  var httpRequest = {
    body: JSON.stringify(data),
    method: "post"
  };

  return httpFetch(url, httpRequest, params, callback);
}


//funktion för att bygga upp en url med parametrar och sätta baseUrl
function getUrl(url, params){
    
    var baseUrl = "https://anstalld.nu/";

    var url = new URL(baseUrl + url);

    if(params)
        url.search = new URLSearchParams(params).toString();
    
    return url;

}

function httpFetchHtml(url, httpRequest, callback) {

    fetch(url, httpRequest).then(function (response) {
        return response.text();
    }).then(function (html) {

        callback(html);
        //console.log(html);
        // Convert the HTML string into a document object
//        var parser = new DOMParser();
  //      var doc = parser.parseFromString(html, 'text/html');

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });

}

function httpFetch(url, httpRequest, params, callback) {

    var url = getUrl(url, params);
    return fetch(url, httpRequest)
    .then(response => {
      return response.json();
    })
    .then(json => {
      if (json.Error) {
        throw json //kasta fel 
         } 
        else 
        {
        
        if(callback)
            callback(json);

        return json;
      }
    })
    .catch(error => {
        console.log(error);
    });
  }